import React, { useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Container,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme} from '@mui/material/styles'
import { Add, FormatAlignCenter, Remove} from '@mui/icons-material';
import MultiInput from './MultiInput';


const EligibleDialog = ({visible,setVisible,handleAdd,setEligible,eligible})=>{

	const theme = useTheme()
	const user = useSelector(state => state?.auth.user);
	const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const dispatch = useDispatch()
    // const [deleting,setDeleting] = useState(false)

	const onOpen = () => {
		setVisible(true);
	};
	const onClose = () => {
		setVisible(false);
	};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<MenuIcon/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Add Eligibility
				</Typography>		
			</Box>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{width:{xs:300,md:400},justifyContent:"center",background:theme.palette.background.default}}>
            <MultiInput
                label="Eligibility *"
                input={eligible}
                isPass={false}
                setInput={setEligible}
            >
                <FormatAlignCenter/>
            </MultiInput>
            <IconButton onClick={(e)=>{
                e?.preventDefault()
                setVisible(false)
                handleAdd()
            }} sx={{marginTop:3,width:100,background:"gold",color:"#000",borderRadius:1,justifyContent:"center",alignItems:"center"}}>
                <Typography style={{fontSize:12,fontFamily:"dinofans",marginLeft:1,marginTop:1}}>
                    Add 
                </Typography>
            </IconButton>
		</DialogContent>
	</Dialog>
	)
}

export default EligibleDialog;